import { render, staticRenderFns } from "./PagemeusGaleriaFotos.vue?vue&type=template&id=22d392bc&scoped=true&"
import script from "./PagemeusGaleriaFotos.vue?vue&type=script&lang=js&"
export * from "./PagemeusGaleriaFotos.vue?vue&type=script&lang=js&"
import style0 from "./PagemeusGaleriaFotos.vue?vue&type=style&index=0&id=22d392bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d392bc",
  null
  
)

export default component.exports